// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Rqtb","overflowing":"ReadFullNote_overflowing__2Jtxz"};